// Включает демонстрационные данные в query-параметрах страницы или hash-роутера VK.
export const isCatalogPreview = () => {
    const pageParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const routePath = hashParams.get("path") || "";
    const routeQuery = routePath.includes("?") ? routePath.slice(routePath.indexOf("?") + 1) : "";

    return pageParams.get("catalog_preview") === "1"
        || hashParams.get("catalog_preview") === "1"
        || new URLSearchParams(routeQuery).get("catalog_preview") === "1";
};

// Данные показывают заполненное игровое поле без обращения к API.
export const catalogPreviewGame = {
    id: 999999,
    isActive: true,
    score: 2480,
    bestScore: 3910,
    comboCount: 4,
    lastWordFoundAt: new Date().toISOString(),
    timeLimitSeconds: 120,
    timeLeft: 97,
    boardRevision: 7,
    grid: [
        ["с", "л", "о", "в", "о", "к"],
        ["и", "г", "р", "а", "л", "а"],
        ["м", "о", "н", "е", "т", "ы"],
        ["т", "у", "р", "н", "и", "р"],
        ["п", "о", "б", "е", "д", "а"],
        ["р", "е", "й", "т", "и", "н"],
    ],
    foundWords: ["слово", "игра", "монеты", "победа"],
    targetWordLengths: [3, 4, 5, 6, 7],
    hintWallet: {time_boost: 1, word_contour: 2},
};

// Данные поддерживают правдоподобное отображение карточек турниров.
export const catalogPreviewTournaments = [
    {
        id: 1001,
        tournament_type: "daily",
        end_at: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(),
        participants_count: 184,
        membership_fee: 30,
        reward: {places: [{coins: 500}, {coins: 300}, {coins: 150}]},
    },
    {
        id: 1002,
        tournament_type: "weekly",
        end_at: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
        participants_count: 1268,
        membership_fee: 80,
        reward: {places: [{coins: 1800}, {coins: 1000}, {coins: 600}]},
    },
    {
        id: 1003,
        tournament_type: "monthly",
        end_at: new Date(Date.now() + 16 * 24 * 60 * 60 * 1000).toISOString(),
        participants_count: 5824,
        membership_fee: 150,
        reward: {places: [{coins: 6000}, {coins: 3500}, {coins: 2000}]},
    },
];

// Возвращает новый локальный путь портрета, исключая старый кеш повреждённых миниатюр.
const catalogPreviewAvatar = (number) => `/catalog-avatars/portrait-v3-${String(number).padStart(2, "0")}.png`;

// Лидеры нужны, чтобы карточки турниров и рейтинга выглядели как активные.
export const catalogPreviewLeaders = [
    {user_id: 101, player_name: "Анна", player_avatar: catalogPreviewAvatar(0), score: 8420},
    {user_id: 102, player_name: "Михаил", player_avatar: catalogPreviewAvatar(8), score: 7980},
    {user_id: 103, player_name: "Елена", player_avatar: catalogPreviewAvatar(1), score: 7310},
];

// Рейтинг отделён от лидеров турнира, так как использует другой контракт API.
export const catalogPreviewRating = [
    {id: 201, name: "Анна Смирнова", avatar: catalogPreviewAvatar(0), weekly_score: 8420, weekly_games: 36},
    {id: 202, name: "Михаил Орлов", avatar: catalogPreviewAvatar(8), weekly_score: 7980, weekly_games: 34},
    {id: 203, name: "Елена Волкова", avatar: catalogPreviewAvatar(1), weekly_score: 7310, weekly_games: 31},
    {id: 204, name: "Алексей Морозов", avatar: catalogPreviewAvatar(9), weekly_score: 6840, weekly_games: 29},
    {id: 205, name: "София Белова", avatar: catalogPreviewAvatar(2), weekly_score: 6530, weekly_games: 28},
    {id: 206, name: "Иван Петров", avatar: catalogPreviewAvatar(10), weekly_score: 6210, weekly_games: 27},
    {id: 207, name: "Мария Соколова", avatar: catalogPreviewAvatar(3), weekly_score: 5940, weekly_games: 25},
    {id: 208, name: "Дмитрий Кузнецов", avatar: catalogPreviewAvatar(11), weekly_score: 5720, weekly_games: 24},
    {id: 209, name: "Ольга Романова", avatar: catalogPreviewAvatar(4), weekly_score: 5490, weekly_games: 23},
    {id: 210, name: "Никита Егоров", avatar: catalogPreviewAvatar(12), weekly_score: 5260, weekly_games: 22},
    {id: 211, name: "Виктория Лебедева", avatar: catalogPreviewAvatar(5), weekly_score: 5030, weekly_games: 21},
    {id: 212, name: "Артём Васильев", avatar: catalogPreviewAvatar(13), weekly_score: 4810, weekly_games: 20},
    {id: 213, name: "Полина Зайцева", avatar: catalogPreviewAvatar(6), weekly_score: 4590, weekly_games: 19},
    {id: 214, name: "Кирилл Фёдоров", avatar: catalogPreviewAvatar(14), weekly_score: 4380, weekly_games: 18},
];

// Текущий игрок остаётся видимым в отдельной карточке рейтинга.
export const catalogPreviewPlayer = {
    id: 999,
    name: "Вы",
    avatar: catalogPreviewAvatar(7),
    weekly_score: 6240,
    weekly_games: 27,
};

// Профиль наполняет стартовый экран данными, которые обычно приходят от API.
export const catalogPreviewHomePlayer = {
    coins: 640,
    available_daily_attempts: 3,
    progression: {
        level: 12,
        title: "Знаток",
        totalScore: 24800,
        currentLevelScore: 22000,
        nextLevelScore: 26000,
    },
};

// Главная страница показывает ближайшую цель и доступные турниры.
export const catalogPreviewMission = {title: "Соберите 40 слов", progress: 32, targetValue: 40, status: "active"};
export const catalogPreviewDailyBonus = {streak: 5, coins: 80, hintRewards: {word_contour: 1}};

// Полный набор миссий показывает все ключевые состояния на отдельной панели.
export const catalogPreviewMissions = {
    daily: [
        {id: 301, title: "Слово за словом", description: "Найдите 25 слов за день", progress: 25, targetValue: 25, targetMetric: "words", timeLeftSeconds: 7 * 3600, status: "completed", rewardPreview: {coins: 70}},
        {id: 302, title: "Длинная цепочка", description: "Составьте 5 слов из шести букв", progress: 3, targetValue: 5, targetMetric: "words", timeLeftSeconds: 7 * 3600, status: "active", rewardPreview: {hint_tokens: {word_contour: 1}}},
        {id: 303, title: "Время играть", description: "Проведите в игре 10 минут", progress: 420, targetValue: 600, targetMetric: "time_played_seconds", timeLeftSeconds: 7 * 3600, status: "active", rewardPreview: {coins: 40}},
    ],
    weekly: [
        {id: 401, title: "Покоритель слов", description: "Найдите 150 слов за неделю", progress: 112, targetValue: 150, targetMetric: "words", timeLeftSeconds: 3 * 24 * 3600, status: "active", rewardPreview: {coins: 250}},
        {id: 402, title: "Победная серия", description: "Завершите 12 игр", progress: 12, targetValue: 12, targetMetric: "games", timeLeftSeconds: 3 * 24 * 3600, status: "completed", rewardPreview: {coins: 180, hint_tokens: {time_boost: 1}}},
        {id: 403, title: "Собранная награда", description: "Завершите 3 ежедневные миссии", progress: 3, targetValue: 3, targetMetric: "missions", timeLeftSeconds: 3 * 24 * 3600, status: "claimed", rewardPreview: {coins: 100}},
    ],
};
